import { z } from "zod";
import { DESCRIPTION, TITLE, CHECKLIST_ITEM, NAME, IMPORTANCE_FLAG } from "./consts";

export const schema = z.object({
  [TITLE]: z.string().min(1, "This field is required"),
  [CHECKLIST_ITEM]: z
  .object({
    [NAME]: z.string().min(1, "This field is required"),
    [IMPORTANCE_FLAG]: z.string().min(1, "This field is required"),
  }).array().min(1, "At least one Checklist Item is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
